import { Storage } from './s3Wrapper';
import { identity } from 'lodash';

import { TAIForm } from 'src/types';

export const fetchSchool = async (aiForm: TAIForm, subKey?: string) => {
  const s3Key = [aiForm.categoryId, subKey].filter(identity).join('/');
  const s3Url = await Storage.get(s3Key, { level: 'private' });
  const s3Data =  await fetch(s3Url).then((response) => response.json());

  //Remap schoolTypeChurch(no longer exists after org subtypes changes) to schoolTypePrivateRel
  if(s3Data.type?.schoolTypeChurch === 'yes'){
    s3Data.type.schoolTypePrivateRel = 'yes';
  }
  return s3Data;
};
